Ext.define('SA.view.TableSection', {
    alias: 'widget.table-section',
    extend: 'SA.view.SimpleContainer',

    items: [
        {
            xtype: 'component',
            itemId: 'scrollFiller'
        }, {
            xtype: 'component',
            autoEl: 'table',
            cls: 'sa-table-section-scroll-frame',
            itemId: 'scrollFrame'
        }
    ],

    addDomEventListener(event, listener) {
        this.el.dom.addEventListener(event, listener);
    },

    getCells() {
        return Array.from(this.el.dom.querySelectorAll('td'));
    },

    getRegion() {
        return SA.view.Region.forEl(this.el.dom);
    },

    getScrollLeft() {
        return this.el.dom.scrollLeft;
    },

    getScrollTop() {
        return this.el.dom.scrollTop;
    },

    isHovered() {
        return getComputedStyle(this.el.dom).getPropertyValue('--hovered').trim() === 'true';
    },

    scrollLeftBy(amount) {
        this.el.dom.scrollBy({top: 0, left: -amount, behavior: 'instant'});
    },

    scrollRightBy(amount) {
        this.el.dom.scrollBy({top: 0, left: amount, behavior: 'instant'});
    },

    setScrollLeft(scrollLeft) {
        this.el.dom.scrollLeft = scrollLeft;
    },

    setScrollTop(scrollTop) {
        this.el.dom.scrollTop = scrollTop;
    }
});